/**
 * Custom no-op polyfill for customElements.
 * Just so that we don't spam sentry with errors.
 */
(function () {
    if (!window.customElements) {
        window.customElements = {};
    }
    if (!window.customElements.define) {
        window.customElements.define = function (name, constructor) {
            console.warn(
                'customElements is not supported in this browser. <' +
                    name +
                    '> html tags will not work'
            );
        };
    }
})();
